import "./form_data_uploader.js";

window.Sparkle ??= {};

window.Sparkle.AssetUploader = class AssetUploader extends Sparkle.FormDataUploader {
  constructor(callbacks, options = {}) {
    super(callbacks);
    this.upload = this.upload.bind(this);
    this.endpoint = options.endpoint || "/admin/assets.json";
  }

  upload(file, options = {}) {
    const formData = new FormData();
    formData.append("asset[file_field]", file);
    if (options.detectFace != null) {
      formData.append("asset[detect_face]", options.detectFace);
    }
    return super.upload(this.endpoint, formData);
  }
};
